export default __webpack_public_path__ + "static/media/suite_c891.777f477d.mp4";